import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class EnumsGroupsService extends BaseService{
	constructor() {
		super('/EnumsGroups');
	}



	public getAllByFilter(filter: EnumsGroupsFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class EnumsGroupsFilter extends BaseFilter {
	constructor(groupIdentifier?: string | null, idGroup?: number | null, isVisible?: boolean | null, idTenant?: number | null) {
		super();
		this._groupIdentifier = groupIdentifier;
		this._idGroup = idGroup;
		this._isVisible = isVisible;
		this._idTenant = idTenant;
	}

	private _groupIdentifier?: string | null;
	private _idGroup?: number | null;
	private _isVisible?: boolean | null;
	private _idTenant?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._groupIdentifier != null ? { GroupIdentifier: this._groupIdentifier } : {}),
			(this._idGroup != null ? { IdGroup: this._idGroup } : {}),
			(this._isVisible != null ? { IsVisible: this._isVisible } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})

		);

		return data;
	};
}